export class Waypoint {

  constructor(index, info) {
    this.index = index
    this.info = info
    this.lat = info.latitude
    this.lng = info.longitude
    this.placeType = info.pointType || 'address'
    this.dwellTime = info.dwellTime || 0
    this.addressName = info.addressName || info.value || ''
    this.via = info.via
  }

  toQueryParamString() {
    let param = {
      originalPosition: {
        course: 360,
        latitude: this.lat,
        longitude: this.lng,
      },
      index: this.index,
      placeType: this.placeType,
      addressName: this.addressName,
      dwellTime: this.dwellTime
    }
    if (['poi', 'facility'].includes(param.placeType)) {
      param.id = this.info.id
    }
    if (this.via && this.via.length) {
      param.via = this.via.map(item => ({ latitude: item.latitude, longitude: item.longitude }))
    }
    return param
  }
}
